import * as React from "react"
import { Card, Divider, Typography, Switch, Checkbox } from "components"
import { Developer } from "types/shop"

interface ShopFilter {
	developers: Developer[]
	setFilters: React.Dispatch<React.SetStateAction<number[]>>
	setShowOnlyAvailable: Dispatch<React.SetStateAction<boolean>>
	filter?: string
	className?: string
}

const ShopFilter: React.FC<ShopFilter> = ({
	developers,
	setFilters,
	setShowOnlyAvailable,
	filter = "",
	className = "",
}) => {
	const initalState = developers.map((item) => {
		if (filter.toLowerCase() === item.name.toLowerCase()) {
			return { name: item.name, value: true }
		}
		return { name: item.name, value: false }
	})

	const [showOnlyAvaliable, setShowOnlyAvaliable] = React.useState(false)
	const [developerFilters, setDeveloperFilters] = React.useState(initalState)

	function onChange(event: React.ChangeEvent<HTMLInputElement>) {
		const item = event.target.name
		const isChecked = event.target.checked
		setDeveloperFilters((prevState) =>
			prevState.map((developer) => {
				if (developer.name === item)
					return {
						...developer,
						value: isChecked,
					}
				return developer
			})
		)
		const { id } = developers.find((developer) => developer.name === item)!
		const removed = !isChecked
		if (removed) {
			setFilters((prevState) => [
				...prevState.filter((item) => item !== id),
			])
		} else {
			setFilters((prevState) => [...prevState, id])
		}
	}

	function switchOnChange(event: React.ChangeEvent<HTMLInputElement>) {
		setShowOnlyAvaliable(event.target.checked)
		setShowOnlyAvailable(event.target.checked)
	}

	return (
		<Card title="امکانات جستجو" className={className}>
			<Switch
				id="show-all-products"
				label="فقط نمایش کالا های موجود"
				checked={showOnlyAvaliable}
				onChange={switchOnChange}
			/>
			<Divider className="my-2" />
			<Typography className="my-2">بر اساس سازنده محصول</Typography>
			{developers.map((developer) => (
				<Checkbox
					key={developer.id}
					id={developer.id.toString()}
					name={developer.name}
					checked={
						developerFilters.find(
							(item) => item.name === developer.name
						)!.value
					}
					onChange={onChange}
				>
					<Typography align="left" className="text-ltr">
						{developer.name}
					</Typography>
				</Checkbox>
			))}
		</Card>
	)
}

export default ShopFilter
